// validates a string is an integer
export const INTEGER_VALIDATION_REGEX = /^\d+$/;

// validates a string is a float
export const FLOAT_VALIDATION_REGEX = /^[-+]?[0-9]+\.[0-9]+$/;
